import React from 'react';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid';
import { Box, IconButton, Typography } from '@mui/material';
import { IPayment } from 'types/payment';
import PaymentStatus from './payment-status';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { colors } from 'common/constants';
import { convertValuePaymentType } from '../constants';
import numeral from 'plugins/numeral';

const PaymentGridCollumn = (
    onClickGridViewIconButton: (row: IPayment) => void
) => {
    const columnsDefinitions: GridColDef[] = [
        {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            width: 45,
        },
        {
            field: 'id',
            headerName: 'ID',
            minWidth: 70,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                >
                    <Typography
                        component="strong"
                        fontWeight="600"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                        color={colors.main}
                    >
                        #{params.row.id}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'productName',
            headerName: 'Sản phẩm',
            flex: 2,
            sortable: true,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                    sx={{
                        textWrap: 'wrap',
                        paddingRight: '15px',
                    }}
                >
                    <Typography
                        component="strong"
                        fontWeight="600"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.productName}
                    </Typography>
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.bonus}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'paymentType',
            headerName: 'Loại',
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Box component="div">
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {convertValuePaymentType(params.row.paymentType)}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'totalAmount',
            headerName: 'Tổng chi phí (VND)',
            flex: 1,
            renderCell: (params) => (
                <Box component="div">
                    <Typography
                        component="strong"
                        fontWeight="600"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                        color={colors.main}
                    >
                        {numeral(params.row.totalAmount).format()} VND
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'time',
            headerName: 'Thời gian',
            flex: 1,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                >
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                        width={'fit-content'}
                        textAlign={'center'}
                    >
                        {params.row.time}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'status',
            headerName: 'Trạng thái',
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    gap={1}
                    alignItems="center"
                    height={'100%'}
                >
                    <PaymentStatus status={params.row.status} />
                </Box>
            ),
        },

        {
            field: 'actions',
            headerName: 'Thao tác',
            sortable: false,
            flex: 1,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    alignItems="center"
                    gap={'12px'}
                    height={'100%'}
                >
                    <IconButton
                        onClick={() => onClickGridViewIconButton(params.row)}
                    >
                        <RemoveRedEyeOutlinedIcon sx={{ color: colors.main }} />
                    </IconButton>
                </Box>
            ),
        },
    ];
    return columnsDefinitions;
};

export default PaymentGridCollumn;
